<template>
  <v-row class="mt-0">
    <v-col
      v-for="(item, index) in items"
      :key="index"
      cols="12" sm="6" md="4" xl="3"
    >
      <v-card
        height="390"
        outlined
        flat
      >
        <div class="d-flex justify-center">
          <v-list-item-avatar
            tile
            size="200"
            class="ml-3"
            color="disabled"
            outlined
          >
            <img v-if="item.base64" :src="`data:image/jpeg;base64,${item.base64}`" />
            <v-icon v-else x-large>fas fa-images</v-icon>
          </v-list-item-avatar>
        </div>
        <div class="d-flex align-center mx-3">
          <v-badge
            v-if="item.stock < 10"
            :content="item.stock"
            :value="item.stock"
            color="deep-orange"
            overlap
            dark
          >
            <v-chip color="orange" small>
              En stock
            </v-chip>
          </v-badge>
          <v-chip v-else color="success" small>
            En stock
          </v-chip>
          <v-spacer></v-spacer>
          <div class="body-2" style="font-size: 12px !important;">
            Cod. Art.: {{ item.articulo_codigo }}
          </div>
        </div>
        <v-card-title class="px-3 py-0" style="word-break: normal;">
          <div
            class="mt-3 font-weight-medium"
            style="font-size: 15px; line-height: normal; min-height: 40px;"
            :title="item.articulo_nombre.length > 40 ? item.articulo_nombre : ''"
          >
            {{ item.articulo_nombre.substring(0, 40) }}
            {{ item.articulo_nombre.length > 40 ? '...' : '' }}
          </div>
        </v-card-title>
        <v-card-title class="d-flex justify-center py-2">
          <span class="text-h6">
            {{ formatMoney(item.precio_unitario) }}
          </span>
        </v-card-title>
        <v-card-actions class="d-flex justify-center">
          <div class="d-flex align-center">
            <v-btn
              color="primary"
              x-small
              icon
              @click="item.cantidad > 0 ? item.cantidad-- : ''"
            >
              <v-icon x-small>fas fa-minus</v-icon>
            </v-btn>
            <v-text-field
              v-model="item.cantidad"
              type="number"
              class="mx-1"
              title="Cantidad"
              style="width: 50px;"
              hide-details
              outlined
              dense
            ></v-text-field>
            <v-btn
              color="primary"
              class="mr-3"
              x-small
              icon
              @click="item.cantidad < item.stock ? item.cantidad++ : ''"
            >
              <v-icon x-small>fas fa-plus</v-icon>
            </v-btn>
            <v-btn
              title="Agregar al carrito"
              class="text-none"
              color="primary"
              :disabled="item.cantidad == 0"
              small
              @click="$emit('carrito', item)"
            >
              Agregar
              <v-icon small right>fas fa-cart-plus</v-icon>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { format_money } from '../../util/utils'

export default {
  data () {
    return {
      formatMoney: format_money
    }
  },
  props: {
    value: Array
  },
  computed: {
    items: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>